// Xhosa translations
export const xh: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Abathengi',
  'menu.products': 'Iimveliso',
  'menu.users': 'Abasebenzisi',
  'menu.settings': 'Iisethingi',
  'menu.logout': 'Phuma',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'I-Oda Entsha',
  'order.title': 'I-Oda Entsha',
  'order.customer': 'Umthengi',
  'order.products': 'Iimveliso',
  'order.total': 'Iyonke',
  'users.title': 'Abasebenzisi',
  'users.name': 'Igama',
  'users.email': 'I-imeyile',
  'common.yes': 'Ewe',
  'common.no': 'Hayi',
  'common.cancel': 'Rhoxisa',
  'common.save': 'Gcina',
  'common.search': 'Khangela',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Ngena',
  'login.welcome': 'Wamkelekile, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'I-imeyile',
  'signup.phone': 'Ifowuni',
  'menu.reportsAndAccounting': 'Iingxelo & Ubalo-mali',
  'menu.systemAndCommunication': 'Inkqubo & Unxibelelwano',
};